import { useNavigate } from 'react-router';
import { ChevronLeft, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { CustomToolsList, NEW_CUSTOM_TOOL_PATH } from '@/modules/integrations/custom-tools';
import { PillButton } from '@/modules/simulator/ui/pill-button';

/** Tools the admin combined from the account's tools, which the AI calls like any other. */
export default function CustomToolsPage() {
	const navigate = useNavigate();

	return (
		<div className='flex flex-col h-full'>
			<div className='sticky top-0 z-10 bg-white flex shrink-0 items-center gap-2 px-4 h-[60px] border-b border-gray-500'>
				<Button
					variant='ghost'
					size='icon'
					className='size-7 rounded-full'
					aria-label='Back to integrations'
					onClick={() => navigate('/settings/integrations')}
				>
					<ChevronLeft size={16} />
				</Button>
				<h1 className='text-base font-semibold'>Custom tools</h1>
				<PillButton variant='primary' className='ml-auto' onClick={() => navigate(NEW_CUSTOM_TOOL_PATH)}>
					<Plus className='size-3.5' />
					New custom tool
				</PillButton>
			</div>

			<div className='flex flex-1 min-h-0 flex-col gap-3 p-6 overflow-auto'>
				<CustomToolsList />
			</div>
		</div>
	);
}
